const color = {
  black: '#000000',
  white: '#ffffff',
  darkRed: '#5B2029',
  pink: '#EAC4C1',
  darkPink: '#D08985',
  milk: '#E7D2BA',
  creamMinded: {
    50: '#FDFCF7',
    100: '#F9F2DF',
    150: '#FBEEC8',
    200: '#ECD8A1',
  },
  mintMinded: {
    100: '#CBF6D2',
    200: '#7FDE8D',
    300: '#6BCA79',
    900: '#17382A',
  },
  pinkMinded: {
    50: '#F8F0FF',
    100: '#F0DEFD',
    300: '#BE9DDC',
    600: '#A48ABC',
  },
  gray: {
    100: '#CDCDCD',
    200: '#8A8A8A',
    300: '#494949',
    400: '#505050',
    500: '#151515',
  },
  red: '#FF4747',
};

const sizes = {
  shortGrid: 315,
  longGrid: 580,
  bookedRooms: 260,
};

const theme = {
  color,
  sizes,
};

export default theme;
